import notifications from "@/modules/Shared/Mixins/notifications.js";
import i18n from "@/i18n";

let openLoaders = 0;

const loader = {
	mixins: [notifications],
	methods: {
		async load(func) {
			if (openLoaders === 0) {
				this.$vs.loading();
			}
			openLoaders++;
			await func()
			openLoaders--;
			if (openLoaders === 0) {
				this.$vs.loading.close();
			}
		},

		async loadAndNotify(action, onlyError = false, ignoreError = false, customErrorMessage = null) {
			try {
				await this.load(action)
				if (!onlyError) {
					this.notifySuccess()
				}
				return true
			} catch (e) {
				console.error(e)
				this.$vs.loading.close();
				if (!ignoreError) {
                    let errorMessage = customErrorMessage
                    if (e.response) {
                        errorMessage = Array.isArray(e.response.data.description)
                            ? e.response.data.description.map(field => `${field.field}: ${field.errors.join(', ')}`).join('\n')
                            : e.response.data.description
                    }
					this.notifyError(i18n.t("shops.error.0"), errorMessage, 10000)
				}
			}
			return false
		},

		async loadAndNotifyError(action, customErrorMessage = null) {
			return this.loadAndNotify(action, true, false, customErrorMessage)
		},

		async loadAndIgnoreError(action) {
			return this.loadAndNotify(action, true, true)
		},
	}
}

export default loader
